<template>
  <div
    class="card"
    style="box-shadow: 0 4px 10px -4px rgba(0, 0, 0, 0.5) !important"
  >
    <div
      class="card-header pb-0 pt-3 d-flex justify-content-between align-items-center"
    >
      <h6>Vendedores</h6>
      <div style="display: flex; gap: 10px">
        <button
          v-if="
            $store.state.user?.type === 'enterprise' &&
            ($store.state.user?.role === 'manager' ||
              $store.state.user?.role === 'admin')
          "
          class="btn btn-success"
          @click="showImportExcelModal = true"
        >
          Importar desde Excel <i class="fas fa-file-excel"></i>
        </button>
        <button
          v-if="
            $store.state.user?.type === 'enterprise' &&
            ($store.state.user?.role === 'admin' ||
              $store.state.user?.role === 'director')
          "
          class="btn btn-warning"
          @click="showInactiveExcelModal = true"
        >
          Inhabilitar desde Excel <i class="fas fa-file-excel"></i>
        </button>
        <button class="btn btn-primary" @click="showAddVendorModal = true">
          Agregar Vendedor <i class="fas fa-user-plus"></i>
        </button>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div v-if="loading" class="container mt-3 mb-3">
        <div class="row mb-3">
          <div class="col-12">
            <Skeletor :shimmer="true" height="30" width="50%" />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Fecha Registro
                  </th>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Nombre
                  </th>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    DNI
                  </th>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Teléfono
                  </th>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Rol
                  </th>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Estado
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="i in 3" :key="i">
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-else-if="error" class="company-info mx-4">
        <p class="mb-0">{{ error }}</p>
      </div>

      <div v-else-if="sellers.length === 0" class="company-info mx-4">
        <p class="mb-0">
          No hay vendedores asociados a esta empresa. Los vendedores que se
          registren aparecerán en esta lista.
        </p>
      </div>

      <!-- Table for Enterprise users with Tienda column -->
      <DataTable
        v-else-if="
          $store.state.user?.type === 'enterprise' &&
          $store.state.user?.role === 'manager' &&
          enterpriseColumns.length === 6
        "
        :key="'sellers-table-enterprise'"
        :columns="enterpriseColumns"
        :options="options"
        :data="sellers"
        class="table tablesorter"
        width="100%"
      >
        <thead>
          <tr>
            <th>Fecha Registro</th>
            <th data-priority="1">Nombre</th>
            <th>DNI</th>
            <th>Tienda</th>
            <th>Rol</th>
            <th>Estado</th>
          </tr>
        </thead>
      </DataTable>

      <!-- Table for Promoter users without Tienda column -->
      <DataTable
        v-else-if="columns.length === 5"
        :key="'sellers-table-promoter'"
        :columns="columns"
        :options="options"
        :data="sellers"
        class="table tablesorter"
        width="100%"
      >
        <thead>
          <tr>
            <th>Fecha Registro</th>
            <th data-priority="1">Nombre</th>
            <th>DNI</th>
            <th>Rol</th>
            <th>Estado</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  </div>

  <!-- Pending Authorized Users Section -->
  <div
    class="card mt-4"
    style="box-shadow: 0 4px 10px -4px rgba(0, 0, 0, 0.5) !important"
  >
    <div class="card-header pb-0 pt-3">
      <h6>Usuarios Pendientes de Registro</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div v-if="loadingPendingUsers" class="container mt-3 mb-3">
        <div class="row mb-3">
          <div class="col-12">
            <Skeletor :shimmer="true" height="30" width="50%" />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Fecha Registro
                  </th>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Nombre
                  </th>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    DNI
                  </th>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Rol
                  </th>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Estado
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="i in 3" :key="i">
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-else-if="pendingUsersError" class="company-info mx-4">
        <p class="mb-0">{{ pendingUsersError }}</p>
      </div>

      <div
        v-else-if="pendingAuthorizedUsers.length === 0"
        class="company-info mx-4"
      >
        <p class="mb-0">No hay usuarios pendientes de registro.</p>
      </div>

      <!-- Table for Enterprise users with Tienda column -->
      <DataTable
        v-else-if="
          $store.state.user?.type === 'enterprise' &&
          $store.state.user?.role === 'manager' &&
          pendingEnterpriseUsersColumns.length === 7
        "
        :key="'pending-users-table-enterprise'"
        :columns="pendingEnterpriseUsersColumns"
        :options="pendingUsersOptions"
        :data="pendingAuthorizedUsers"
        class="table tablesorter"
        width="100%"
      >
        <thead>
          <tr>
            <th>Fecha Registro</th>
            <th data-priority="1">Nombre</th>
            <th>DNI</th>
            <th>Tienda</th>
            <th>Rol</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
      </DataTable>

      <!-- Table for Promoter users without Tienda column -->
      <DataTable
        v-else-if="pendingUsersColumns.length === 6"
        :key="'pending-users-table-promoter'"
        :columns="pendingUsersColumns"
        :options="pendingUsersOptions"
        :data="pendingAuthorizedUsers"
        class="table tablesorter"
        width="100%"
      >
        <thead>
          <tr>
            <th>Fecha Registro</th>
            <th data-priority="1">Nombre</th>
            <th>DNI</th>
            <th>Rol</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  </div>

  <!-- Add Vendor Modal -->
  <VueFinalModal
    v-model="showAddVendorModal"
    :esc-to-close="false"
    :click-to-close="false"
    :prevent-click="false"
    class="modal-container"
    content-class="modal-content4"
  >
    <div class="modal-header">
      <h5 class="modal-title">Agregar Vendedor</h5>
      <button
        type="button"
        class="btn-close"
        @click="showAddVendorModal = false"
      ></button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label for="dni">DNI del Vendedor</label>
        <div style="display: flex; gap: 10px; height: fit-content">
          <input
            type="text"
            class="form-control"
            id="dni"
            v-model="vendorData.dni"
            placeholder="Ingrese el DNI"
            :disabled="loadingDni"
          />
          <button
            class="btn btn-primary"
            @click="fetchPersonByDni"
            style="display: flex; align-items: center; gap: 10px"
            :disabled="loadingDni || !vendorData.dni"
          >
            <i class="fas fa-search" v-if="!loadingDni"></i>
            <i class="fas fa-spinner fa-spin" v-else></i>
            Buscar
          </button>
        </div>
      </div>

      <div v-if="vendorData.names" class="company-info mt-4">
        <h6>Información del Vendedor</h6>
        <div class="info-item"><strong>DNI:</strong> {{ vendorData.dni }}</div>
        <div class="info-item">
          <strong>Nombre:</strong> {{ vendorData.names }}
        </div>
        <div class="info-item">
          <strong>Apellidos:</strong> {{ vendorData.lastnames }}
        </div>
        <div
          v-if="
            $store.state.user?.type === 'enterprise' &&
            $store.state.user?.role === 'manager'
          "
          class="info-item"
        >
          <strong>Tienda (*):</strong>
          <input
            type="text"
            class="form-control"
            v-model="vendorData.branch"
            placeholder="Ingrese el número de tienda"
            required
          />
          <small class="form-text text-muted">
            Número de tienda asignada al vendedor
          </small>
        </div>
        <!-- <div class="info-item">
          <strong>Teléfono:</strong>
          <MazPhoneNumberInput
            type="tel"
            default-country-code="EC"
            style="width: 100%"
            no-flags
            no-example
            required
            show-code-on-list
            size="sm"
            v-model="vendorData.phoneNumber"
            @update:value="vendorData.phoneNumber = $event"
            :translations="{
              countrySelector: {
                placeholder: 'Código',
                error: 'Elija un pais',
              },
              phoneInput: {
                placeholder: 'Nro. celular',
                example: 'Ejemplo:',
              },
            }"
          />
        </div> -->
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        @click="showAddVendorModal = false"
      >
        Cancelar
      </button>
      <button
        type="button"
        class="btn btn-primary"
        @click="saveVendor"
        :disabled="!isVendorFormValid || loading"
      >
        Guardar
      </button>
    </div>
  </VueFinalModal>

  <!-- Import Excel Modal -->
  <VueFinalModal
    v-model="showImportExcelModal"
    :esc-to-close="false"
    :click-to-close="false"
    :prevent-click="false"
    class="modal-container"
    content-class="modal-content4"
  >
    <div class="modal-header">
      <h5 class="modal-title">Importar Vendedores desde Excel</h5>
      <button
        type="button"
        class="btn-close"
        @click="showImportExcelModal = false"
      ></button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label for="excelFile">Seleccionar archivo Excel (.xlsx, .xls)</label>
        <input
          type="file"
          class="form-control"
          id="excelFile"
          accept=".xlsx,.xls"
          @change="handleFileSelect"
          :disabled="loadingImport"
        />
        <small class="form-text text-muted">
          Formato estándar: CI, Nombre 1, Nombre 2, Apellido 1, Apellido 2,
          Telefono Oficina, Ciudad, NOMBRE ALMACEN NUEVO, CARGO. Formato CRESA:
          CÉDULA, COLABORADOR, CELULAR, CIUDAD, TIENDA, CODIGO.
        </small>
      </div>
      <div v-if="importPreview.length > 0" class="mt-3">
        <h6>Vista previa ({{ importPreview.length }} vendedores):</h6>
        <div
          class="table-responsive"
          style="max-height: 300px; overflow-y: auto"
        >
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>DNI</th>
                <th>Nombres</th>
                <th>Apellidos</th>
                <th>Teléfono</th>
                <th>Ciudad</th>
                <th>Branch</th>
                <th>Código</th>
                <th>Rol</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in importPreview" :key="index">
                <td>{{ row.dni || "N/A" }}</td>
                <td>{{ row.names || "N/A" }}</td>
                <td>{{ row.lastnames || "N/A" }}</td>
                <td>{{ row.phone || "N/A" }}</td>
                <td>{{ row.city || "N/A" }}</td>
                <td>{{ row.branch || "N/A" }}</td>
                <td>{{ row.employeeCode || "N/A" }}</td>
                <td>{{ row.role || "N/A" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        @click="showImportExcelModal = false"
        :disabled="loadingImport"
      >
        Cancelar
      </button>
      <button
        type="button"
        class="btn btn-primary"
        @click="importVendorsFromExcel"
        :disabled="importPreview.length === 0 || loadingImport"
      >
        <i class="fas fa-spinner fa-spin" v-if="loadingImport"></i>
        <span v-else>Importar {{ importPreview.length }} vendedores</span>
      </button>
    </div>
  </VueFinalModal>

  <!-- Inhabilitar desde Excel Modal -->
  <VueFinalModal
    v-model="showInactiveExcelModal"
    :esc-to-close="false"
    :click-to-close="false"
    class="modal-container"
    content-class="modal-content4"
  >
    <div class="modal-header">
      <h5 class="modal-title">Inhabilitar vendedores desde Excel</h5>
      <button
        type="button"
        class="btn-close"
        @click="showInactiveExcelModal = false"
      ></button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label for="inactiveExcelFile"
          >Seleccionar archivo Excel (.xlsx, .xls)</label
        >
        <input
          type="file"
          class="form-control"
          id="inactiveExcelFile"
          accept=".xlsx,.xls"
          @change="handleInactiveFileSelect"
          :disabled="loadingInactive"
        />
        <small class="form-text text-muted">
          Excel con columna de DNI: "# Empleado" (bajas), CÉDULA (CRESA) o CI.
          Se pondrá status inactivo a esos vendedores de la empresa actual.
        </small>
      </div>
      <div v-if="inactivePreview.length > 0" class="mt-3">
        <h6>Vista previa ({{ inactivePreview.length }} DNI a inhabilitar):</h6>
        <div
          class="table-responsive"
          style="max-height: 300px; overflow-y: auto"
        >
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>DNI</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in inactivePreview" :key="index">
                <td>{{ item.dni }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        @click="showInactiveExcelModal = false"
        :disabled="loadingInactive"
      >
        Cancelar
      </button>
      <button
        type="button"
        class="btn btn-warning"
        @click="inhabilitarVendorsFromExcel"
        :disabled="inactivePreview.length === 0 || loadingInactive"
      >
        <i class="fas fa-spinner fa-spin" v-if="loadingInactive"></i>
        <span v-else>Inhabilitar {{ inactivePreview.length }} vendedores</span>
      </button>
    </div>
  </VueFinalModal>
</template>

<script>
/* eslint-disable */
import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import "datatables.net-responsive";
import { Skeletor } from "vue-skeletor";
import "vue-skeletor/dist/vue-skeletor.css";
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";
import $ from "jquery";
import * as XLSX from "xlsx";

DataTable.use(DataTablesCore);

export default {
  name: "Vendedores",
  components: {
    DataTable,
    Skeletor,
    VueFinalModal,
  },
  data() {
    return {
      loading: true,
      loadingDni: false,
      loadingPendingUsers: true,
      sellers: [],
      pendingAuthorizedUsers: [],
      error: null,
      pendingUsersError: null,
      userId: this.$store.state.user.userId,
      tokenAuth: this.$store.state.tokenAuth,
      companyId: this.$store.state.user.companyId,
      companyName: this.$store.state.user.companyName,
      companyType: null,
      apiError: false,
      showAddVendorModal: false,
      showImportExcelModal: false,
      importPreview: [],
      loadingImport: false,
      showInactiveExcelModal: false,
      inactivePreview: [],
      loadingInactive: false,
      vendorData: {
        dni: "",
        names: "",
        lastnames: "",
        namesList: [],
        lastnamesList: [],
        role: "user", // Default role for vendors
        branch: "",
      },
      columns: [],
      enterpriseColumns: [],
      options: {
        responsive: true,
        ordering: false,
        columnDefs: [
          { responsivePriority: 1, targets: 0 },
          { responsivePriority: 2, targets: -1 },
        ],
        lengthMenu: [
          [10, 25, 50, -1],
          [10, 25, 50, "Todos"],
        ],
        pageLength: 10,
        language: {
          search: "Buscar:",
          sInfo:
            "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          sInfoEmpty:
            "Mostrando registros del 0 al 0 de un total de 0 registros",
          searchPlaceholder: "Buscar por término...",
          zeroRecords: "Lo sentimos, no se encontraron resultados",
          processing: "Buscando. Espere por favor...",
          sLengthMenu: "Mostrar _MENU_ registros",
          oPaginate: {
            sFirst: "Primero",
            sLast: "Último",
            sNext: "Siguiente",
            sPrevious: "Anterior",
          },
        },
      },
      pendingUsersColumns: [],
      pendingEnterpriseUsersColumns: [],
      pendingUsersOptions: {
        responsive: true,
        ordering: false,
        columnDefs: [
          { responsivePriority: 1, targets: 0 },
          { responsivePriority: 2, targets: -1 },
        ],
        lengthMenu: [
          [10, 25, 50, -1],
          [10, 25, 50, "Todos"],
        ],
        pageLength: 10,
        language: {
          search: "Buscar:",
          sInfo:
            "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          sInfoEmpty:
            "Mostrando registros del 0 al 0 de un total de 0 registros",
          searchPlaceholder: "Buscar por término...",
          zeroRecords: "Lo sentimos, no se encontraron resultados",
          processing: "Buscando. Espere por favor...",
          sLengthMenu: "Mostrar _MENU_ registros",
          oPaginate: {
            sFirst: "Primero",
            sLast: "Último",
            sNext: "Siguiente",
            sPrevious: "Anterior",
          },
        },
      },
    };
  },
  computed: {
    isVendorFormValid() {
      const baseValid =
        this.vendorData.dni &&
        this.vendorData.names &&
        this.vendorData.lastnames &&
        this.vendorData.namesList &&
        this.vendorData.lastnamesList;

      // Si el usuario es enterprise y manager, también requiere branch
      if (
        this.$store.state.user?.type === "enterprise" &&
        this.$store.state.user?.role === "manager"
      ) {
        return (
          baseValid &&
          this.vendorData.branch &&
          this.vendorData.branch.trim() !== ""
        );
      }

      return baseValid;
    },
  },
  mounted() {
    // Initialize columns first (will be updated after companyType is fetched)
    this.updateColumns(); // This will also call updatePendingUsersColumns()
    this.fetchSellers();
    this.fetchPendingAuthorizedUsers();
    this.fetchCompanyType();

    // Add event listener for delete buttons
    $(document).on("click", ".delete-pending-user", (evt) => {
      evt.stopPropagation();
      const button = $(evt.currentTarget);
      const userData = {
        id: button.data("id"),
        dni: button.data("dni"),
      };
      console.log("userData", userData);
      this.deletePendingUser(userData);
    });
  },
  methods: {
    fetchSellers() {
      this.loading = true;
      this.error = null;

      // Show warning if no companyId is set
      if (!this.companyId) {
        this.$toast.warning(
          "No se ha configurado un ID de empresa. Se mostrarán todos los vendedores.",
          {
            position: "top-right",
            max: 10,
          },
        );
      }

      // Try to fetch users by company first
      this.$https
        .post("administration/fetchUsersByCompany/", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
          companyId: this.companyId || "default", // Provide a default if not set
        })
        .then((response) => {
          const incoming = response.data.users || [];
          this.sellers = Array.isArray(incoming)
            ? incoming.filter((u) => u && u.isDeleted !== true)
            : [];
          this.apiError = false;

          if (this.sellers.length === 0) {
            this.$toast.info(
              "No se encontraron vendedores asociados a esta empresa.",
              {
                position: "top-right",
                max: 10,
              },
            );
          }
        })
        .catch((error) => {
          console.error("Error fetching sellers by company:", error);

          // Check if error is 404 Not Found (endpoint doesn't exist)
          if (error.response && error.response.status === 404) {
            this.$toast.warning(
              "El endpoint para filtrar por empresa no está disponible. Usando método alternativo.",
              {
                position: "top-right",
                max: 10,
              },
            );
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fetchPendingAuthorizedUsers() {
      this.loadingPendingUsers = true;
      this.pendingUsersError = null;

      // Check if companyId is set
      if (!this.companyId) {
        this.$toast.warning(
          "No se ha configurado un ID de empresa. No se pueden mostrar usuarios pendientes de registro.",
          {
            position: "top-right",
            max: 10,
          },
        );
        this.loadingPendingUsers = false;
        return;
      }

      // Fetch whitelist and filter by company and isPending status
      this.$https
        .post("administration/fetchWhitelistByCompany/", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
          companyId: this.companyId,
        })
        .then((response) => {
          const whitelist = response.data.whitelist || [];
          // Filter users by company and isPending = true
          this.pendingAuthorizedUsers = whitelist.filter(
            (user) =>
              user.companyId === this.companyId && user.isPending === true,
          );

          if (this.pendingAuthorizedUsers.length === 0) {
            this.$toast.success("No hay vendedores pendientes de registro.", {
              position: "top-right",
              max: 10,
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching pending authorized users:", error);
          this.pendingUsersError =
            "Error al cargar los vendedores pendientes de registro.";
          this.$toast.error(
            error.response?.data?.message ||
              "Error al cargar usuarios pendientes",
            {
              position: "top-right",
              max: 10,
            },
          );
        })
        .finally(() => {
          this.loadingPendingUsers = false;
        });
    },

    splitSpanishName(fullName) {
      const particles = ["DE", "LA", "DEL", "LAS", "LOS", "SAN", "SANTA"]; // List of particles in uppercase
      const nameParts = fullName.trim().split(/\s+/); // Split the name into individual words
      let lastnames = []; // This will hold the lastnames
      let names = []; // This will hold the names
      let tempList = []; // Temporary list to hold current group of words
      let i = 0;
      let lastnamesNumber = 0;

      // Handle first part for lastnames (grouping particles and first last name)
      while (lastnamesNumber < 2) {
        while (i < nameParts.length) {
          const currentWord = nameParts[i].toUpperCase();
          if (particles.includes(currentWord)) {
            // If it's a particle, add to tempList
            tempList.push(currentWord);
            i++;
          } else {
            // Stop when a non-particle word is encountered
            tempList.push(nameParts[i]);
            lastnames.push(tempList.join(" ")); // Save lastnames
            tempList = []; // Reset tempList for next part
            i++; // Move to the next word
            break; // Stop the loop for lastnames part
          }
        }
        lastnamesNumber++;
      }

      // Handle second part for names (grouping the remaining names)
      while (i < nameParts.length) {
        const currentWord = nameParts[i];

        if (particles.includes(currentWord)) {
          // If it's a particle, add to tempList
          tempList.push(currentWord);
          i++;
        } else {
          // Otherwise, add word to names
          tempList.push(currentWord);
          names.push(tempList.join(" ")); // Save names
          tempList = []; // Reset tempList for next part
          i++;
        }
      }
      // Return the split result: first part is lastnames, second part is names
      return {
        lastnames: lastnames.join(" "), // Join all parts for lastnames
        names: names.join(" "), // Join all parts for names
        lastnamesList: lastnames,
        namesList: names,
      };
    },

    fetchPersonByDni() {
      if (!this.vendorData.dni) return;

      this.loadingDni = true;
      this.$https
        .post("/administration/fetchDniData", {
          dni: this.vendorData.dni,
        })
        .then((response) => {
          const { names, lastnames, namesList, lastnamesList } =
            this.splitSpanishName(response.data.dataGeneral.nombres);
          this.vendorData.names = names;
          this.vendorData.lastnames = lastnames;
          this.vendorData.namesList = namesList;
          this.vendorData.lastnamesList = lastnamesList;
          this.loadingDni = false;
        })
        .catch((error) => {
          this.loadingDni = false;
          this.$toast.error(
            error.response?.data?.message || "Error al validar DNI",
            {
              position: "top-right",
              max: 10,
            },
          );
        });
    },

    saveVendor() {
      if (!this.isVendorFormValid) return;

      this.loading = true;

      // Add company ID to vendor data
      const vendorToSave = {
        ...this.vendorData,
        companyId: this.companyId,
        companyName: this.companyName,
      };

      this.$https
        .post("/administration/addSalesRepresentative/", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
          userData: vendorToSave,
        })
        .then((response) => {
          this.loading = false;
          this.showAddVendorModal = false;
          this.$toast.success("Vendedor agregado exitosamente", {
            position: "top-right",
            max: 10,
          });
          // Refresh the list of sellers
          this.fetchSellers();
          // Refresh the list of pending authorized users
          this.fetchPendingAuthorizedUsers();
          // Reset vendor data
          this.vendorData = {
            dni: "",
            names: "",
            lastnames: "",
            namesList: [],
            lastnamesList: [],
            role: "user",
            branch: "",
          };
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.error(
            error.response?.data?.message || "Error al agregar vendedor",
            {
              position: "top-right",
              max: 10,
            },
          );
        });
    },

    // Add delete pending authorized user method
    deletePendingUser(userData) {
      if (!userData || !userData.id) {
        this.$toast.error("No se pudo identificar al usuario para eliminar", {
          position: "top-right",
          max: 10,
        });
        return;
      }

      // Use SweetAlert2 for confirmation instead of basic confirm
      this.$swal({
        title: "¿Está seguro?",
        text: `¿Desea eliminar al usuario pendiente de registro con DNI ${userData.dni}?`,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-secondary ml-1",
        },
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        allowOutsideClick: true,
        backdrop: true,
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          // Show loading state
          this.$swal({
            html: '<div class="row"><div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div><div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1"><div class="loader"></div></div><div class="col-7 col-sm-7 col-md-7 col-lg-7 col-xl-7"><p style="margin:0px; font-size:16px; text-align:center; font-weight:bold">Eliminando usuario...</p></div><div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div></div>',
            showCloseButton: false,
            showCancelButton: false,
            focusConfirm: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
            showConfirmButton: false,
            position: "top",
          });

          this.$https
            .post("administration/deleteWhitelistUser/", {
              tokenAuth: this.tokenAuth,
              userId: this.userId,
              whitelistId: userData.id,
              companyId: this.companyId,
            })
            .then((response) => {
              this.$swal.close();
              this.$toast.success("Usuario eliminado exitosamente", {
                position: "top-right",
                max: 10,
              });
              // Refresh the list of pending authorized users
              this.fetchPendingAuthorizedUsers();
            })
            .catch((error) => {
              this.$swal.close();
              console.error("Error deleting pending user:", error);
              this.$toast.error(
                error.response?.data?.message ||
                  "Error al eliminar usuario pendiente",
                {
                  position: "top-right",
                  max: 10,
                },
              );
            });
        }
      });
    },

    async fetchCompanyType() {
      if (!this.companyId) {
        // Initialize columns with default (promoter) if no companyId
        this.updateColumns();
        return;
      }

      try {
        const response = await this.$https.post(
          "/administration/fetchCompanyDetails/",
          {
            tokenAuth: this.tokenAuth,
            userId: this.userId,
            companyId: this.companyId,
          },
        );
        this.companyType = response.data.company?.type || null;
        console.log("Company type fetched:", this.companyType);
        // Update columns after getting company type
        this.updateColumns();
      } catch (error) {
        console.error("Error fetching company type:", error);
        // Initialize columns with default on error
        this.updateColumns();
      }
    },

    updateColumns() {
      // Base column definitions (reusable)
      const baseColumnDef = {
        createdAt: {
          data: "createdAt",
          render: function (data) {
            if (!data) return "-";
            const date = new Date(data._seconds * 1000);
            return date.toLocaleString("es-ES", {
              timeZone: "America/Guayaquil",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            });
          },
        },
        name: {
          data: null,
          render: function (data) {
            return `${data.names || "-"} ${data.lastnames || "-"}`;
          },
        },
        dni: { data: "dni" },
        branch: {
          data: null,
          render: function (data, type, row) {
            return row.branch || "-";
          },
        },
        role: {
          data: "role",
          render: function (data) {
            const roleMap = {
              admin: "Administrador",
              manager: "Gerente",
              salesRep: "Vendedor",
            };
            return roleMap[data] || data;
          },
        },
        status: {
          data: null,
          render: function (data) {
            return data.isProfileCompleted ? "Registrado" : "No Registrado";
          },
        },
      };

      // Columns for promoter (without branch) - 5 columns
      this.columns = [
        baseColumnDef.createdAt,
        baseColumnDef.name,
        baseColumnDef.dni,
        baseColumnDef.role,
        baseColumnDef.status,
      ];

      // Columns for enterprise users (admin, director, supervisor, manager) - 6 columns
      const userRole = this.$store.state.user?.role;
      const userType = this.$store.state.user?.type; // User's type, not company's type
      const isEnterprise = userType === "enterprise";
      // Admin, director, supervisor y manager son roles enterprise que ven branch
      const isEnterpriseRole = [
        "admin",
        "director",
        "supervisor",
        "manager",
      ].includes(userRole);

      if (isEnterprise && isEnterpriseRole) {
        this.enterpriseColumns = [
          baseColumnDef.createdAt,
          baseColumnDef.name,
          baseColumnDef.dni,
          baseColumnDef.branch,
          baseColumnDef.role,
          baseColumnDef.status,
        ];
      } else {
        // If not enterprise user or not enterprise role, use same columns as promoter (sin branch)
        this.enterpriseColumns = this.columns;
      }

      // Update pending users columns
      this.updatePendingUsersColumns();
    },

    updatePendingUsersColumns() {
      // Base column definitions for pending users
      const basePendingColumnDef = {
        createdAt: {
          data: "createdAt",
          render: function (data) {
            if (!data) return "-";
            const date = new Date(data._seconds * 1000);
            return date.toLocaleString("es-ES", {
              timeZone: "America/Guayaquil",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            });
          },
        },
        name: {
          data: null,
          render: function (data) {
            return `${data.names || "-"} ${data.lastnames || "-"}`;
          },
        },
        dni: { data: "dni" },
        branch: {
          data: null,
          render: function (data, type, row) {
            return row.branch || "-";
          },
        },
        role: {
          data: "role",
          render: function (data) {
            const roleMap = {
              admin: "Administrador",
              manager: "Gerente",
              user: "Vendedor",
              salesRep: "Vendedor",
            };
            return roleMap[data] || data;
          },
        },
        status: {
          data: "isPending",
          render: function (data) {
            return data ? "Pendiente" : "Registrado";
          },
        },
        actions: {
          data: null,
          orderable: false,
          render: function (data, type, row) {
            return `<button class="btn btn-sm btn-danger delete-pending-user" 
              data-id="${data.authorizedUserId}" 
              data-dni="${data.dni}">
              Eliminar <i class="fas fa-trash"></i>
            </button>`;
          },
        },
      };

      // Columns for promoter users (without branch) - 6 columns
      this.pendingUsersColumns = [
        basePendingColumnDef.createdAt,
        basePendingColumnDef.name,
        basePendingColumnDef.dni,
        basePendingColumnDef.role,
        basePendingColumnDef.status,
        basePendingColumnDef.actions,
      ];

      // Columns for enterprise users with admin or manager role (with branch) - 7 columns
      const userRole = this.$store.state.user?.role;
      const userType = this.$store.state.user?.type; // User's type, not company's type
      const isEnterprise = userType === "enterprise";
      const isEnterpriseRole = userRole === "admin" || userRole === "manager";

      if (isEnterprise && isEnterpriseRole) {
        this.pendingEnterpriseUsersColumns = [
          basePendingColumnDef.createdAt,
          basePendingColumnDef.name,
          basePendingColumnDef.dni,
          basePendingColumnDef.branch,
          basePendingColumnDef.role,
          basePendingColumnDef.status,
          basePendingColumnDef.actions,
        ];
      } else {
        // If not enterprise user or not enterprise role, use same columns as promoter (sin branch)
        this.pendingEnterpriseUsersColumns = this.pendingUsersColumns;
      }
    },

    handleFileSelect(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, {
            type: "array",
            cellText: false,
            cellDates: false,
          });
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];

          // Read as JSON but preserve text format for branch column
          const jsonData = XLSX.utils.sheet_to_json(firstSheet, {
            raw: false, // Read all cells as text to preserve leading zeros
            defval: "",
          });

          // Debug: log column names from first row
          const columns = jsonData.length > 0 ? Object.keys(jsonData[0]) : [];
          if (jsonData.length > 0) {
            console.log("Excel columns found:", columns);
          }

          // Detectar formato CRESA (CÉDULA, COLABORADOR, CELULAR, CIUDAD, TIENDA, CODIGO)
          const isCresaFormat =
            columns.some((c) => c === "CÉDULA" || c === "CEDULA") &&
            columns.some((c) => c === "COLABORADOR");

          const processedUsers = isCresaFormat
            ? this.processExcelRowsCresaFormat(
                jsonData,
                this.companyId,
                this.companyName,
              )
            : this.processExcelRowsToUserObjects(
                jsonData,
                this.companyId,
                this.companyName,
              );

          // Filtrar usuarios válidos (DNI y nombres; para formato estándar también teléfono)
          this.importPreview = processedUsers.filter(
            (user) =>
              user.dni &&
              user.dni.trim() !== "" &&
              user.names &&
              user.names.trim() !== "" &&
              (isCresaFormat || (user.phone && user.phone.trim() !== "")),
          );

          if (this.importPreview.length === 0) {
            this.$toast.warning(
              "No se encontraron datos válidos en el archivo Excel",
              { position: "top-right", max: 10 },
            );
          } else {
            // Imprimir todos los datos procesados
            console.log("==========================================");
            console.log("USUARIOS PROCESADOS DEL EXCEL:");
            console.log("Total de registros:", this.importPreview.length);
            console.log("==========================================");
            console.log(
              "Datos completos:",
              JSON.stringify(this.importPreview, null, 2),
            );
            console.log("==========================================");
            console.table(this.importPreview);
            console.log("==========================================");
          }
        } catch (error) {
          console.error("Error reading Excel file:", error);
          this.$toast.error("Error al leer el archivo Excel", {
            position: "top-right",
            max: 10,
          });
        }
      };
      reader.readAsArrayBuffer(file);
    },

    async importVendorsFromExcel() {
      if (this.importPreview.length === 0) return;

      this.loadingImport = true;

      try {
        // Los objetos ya están en el formato correcto desde processExcelRowsToUserObjects
        const response = await this.$https.post(
          "/administration/importUsersFromExcel/",
          {
            tokenAuth: this.tokenAuth,
            userId: this.userId,
            users: this.importPreview,
          },
        );

        this.loadingImport = false;
        this.showImportExcelModal = false;
        this.importPreview = [];

        this.$toast.success(
          response.data.message ||
            `${response.data.successCount} usuarios importados (${response.data.createdCount ?? "-"} creados, ${response.data.updatedCount ?? "-"} actualizados)${
              response.data.errorCount > 0
                ? `. ${response.data.errorCount} errores.`
                : ""
            }`,
          { position: "top-right", max: 10, duration: 5000 },
        );

        // Mostrar errores si los hay
        if (response.data.errors && response.data.errors.length > 0) {
          console.error(
            "Errores durante la importación:",
            response.data.errors,
          );
        }

        // Refresh lists
        this.fetchSellers();
        this.fetchPendingAuthorizedUsers();
      } catch (error) {
        this.loadingImport = false;
        this.$toast.error(
          error.response?.data?.message || "Error al procesar datos",
          { position: "top-right", max: 10 },
        );
      }
    },

    handleInactiveFileSelect(event) {
      const file = event.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, {
            type: "array",
            cellText: false,
            cellDates: false,
          });
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          const jsonData = XLSX.utils.sheet_to_json(firstSheet, {
            raw: false,
            defval: "",
          });
          const columns = jsonData.length > 0 ? Object.keys(jsonData[0]) : [];
          // DNI puede venir como: "# Empleado" (bajas), "CÉDULA"/"CEDULA" (CRESA), "CI" (estándar)
          const dniKeys = [
            "# Empleado",
            "CÉDULA",
            "CEDULA",
            "CI",
            "Cédula",
            "Cedula",
          ];
          const dniKey = dniKeys.find((k) => columns.includes(k));
          const dnis = new Set();
          const normalizeDni = (val) => {
            const s = String(val).trim().replace(/\s/g, "");
            if (!s) return null;
            // Si son solo dígitos y tienen 9 caracteres (Ecuador), agregar 0 al inicio
            if (/^\d+$/.test(s) && s.length === 9) return "0" + s;
            return s;
          };
          jsonData.forEach((row) => {
            const raw = dniKey
              ? row[dniKey]
              : (row["# Empleado"] ??
                row["CÉDULA"] ??
                row["CEDULA"] ??
                row["CI"]);
            const dni = normalizeDni(raw);
            if (dni) dnis.add(dni);
          });
          this.inactivePreview = [...dnis].map((dni) => ({ dni }));
          if (this.inactivePreview.length === 0) {
            this.$toast.warning("No se encontraron DNI en el archivo", {
              position: "top-right",
              max: 10,
            });
          }
          event.target.value = "";
        } catch (err) {
          console.error("Error reading Excel:", err);
          this.$toast.error("Error al leer el archivo Excel", {
            position: "top-right",
            max: 10,
          });
        }
      };
      reader.readAsArrayBuffer(file);
    },

    async inhabilitarVendorsFromExcel() {
      if (this.inactivePreview.length === 0) return;
      this.loadingInactive = true;
      try {
        const response = await this.$https.post(
          "/administration/setProfilesInactiveFromExcel/",
          {
            tokenAuth: this.tokenAuth,
            userId: this.userId,
            companyId: this.companyId,
            companyName: this.companyName,
            dnis: this.inactivePreview.map((x) => x.dni),
          },
        );
        this.loadingInactive = false;
        this.showInactiveExcelModal = false;
        this.inactivePreview = [];
        const n = response.data.deactivatedCount ?? 0;
        this.$toast.success(
          `Se inhabilitaron correctamente ${n} vendedor${n !== 1 ? "es" : ""}.${response.data.notFoundCount ? ` ${response.data.notFoundCount} DNI no encontrados en esta empresa.` : ""}`,
          { position: "top-right", max: 10, duration: 5000 },
        );
        if (
          response.data.notFoundDnis &&
          response.data.notFoundDnis.length > 0
        ) {
          this.$toast.warning(
            `DNI no encontrados: ${response.data.notFoundDnis.slice(0, 5).join(", ")}${response.data.notFoundDnis.length > 5 ? "..." : ""}`,
            { position: "top-right", max: 10, duration: 6000 },
          );
        }
        this.fetchSellers();
        this.fetchPendingAuthorizedUsers();
      } catch (error) {
        this.loadingInactive = false;
        this.$toast.error(
          error.response?.data?.message || "Error al inhabilitar",
          { position: "top-right", max: 10 },
        );
      }
    },

    /**
     * Formato CRESA: columnas CÉDULA, COLABORADOR, CELULAR, CIUDAD, TIENDA, CODIGO.
     * COLABORADOR viene como "apellido1 apellido2 nombre1 nombre2" (ej: MIÑARCAJA ALULEMA LIDER IVAN).
     * Regla: primeras 2 palabras = apellidos, resto = nombres.
     * CELULAR es opcional; CODIGO se usa para identificarse en WhatsApp.
     */
    processExcelRowsCresaFormat(excelRows, companyId, companyName) {
      const processPhone = (phone) => {
        if (!phone) return null;
        let processed = String(phone).trim();
        processed = processed.replace(/\s+/g, "").replace(/[^\d+]/g, "");
        if (processed.startsWith("0")) processed = processed.substring(1);
        if (!processed.startsWith("+593")) processed = "+593" + processed;
        return processed;
      };
      const processEmployeeCode = (codigo) => {
        if (!codigo) return null;
        return String(codigo).trim().toUpperCase();
      };
      // apellido1 apellido2 nombre1 nombre2 → lastnames = partes 0-1, names = partes 2+
      const splitColaborador = (colaborador) => {
        const parts = String(colaborador || "")
          .trim()
          .split(/\s+/)
          .filter((p) => p.length > 0);
        if (parts.length <= 1) {
          return {
            names: parts[0] || "",
            lastnames: "",
            namesList: parts.length ? [parts[0]] : [],
            lastnamesList: [],
          };
        }
        if (parts.length === 2) {
          return {
            names: parts[1],
            lastnames: parts[0],
            namesList: [parts[1]],
            lastnamesList: [parts[0]],
          };
        }
        const lastnamesList = parts.slice(0, 2); // apellido1, apellido2
        const namesList = parts.slice(2); // nombre1, nombre2, ...
        return {
          lastnames: lastnamesList.join(" "),
          names: namesList.join(" "),
          lastnamesList,
          namesList,
        };
      };
      const getCol = (row, ...keys) => {
        for (const k of keys) {
          if (
            row[k] !== undefined &&
            row[k] !== null &&
            String(row[k]).trim() !== ""
          ) {
            return String(row[k]).trim();
          }
        }
        return "";
      };
      return excelRows
        .map((row) => {
          const dni = getCol(row, "CÉDULA", "CEDULA");
          const colaborador = getCol(row, "COLABORADOR");
          const { names, lastnames, namesList, lastnamesList } =
            splitColaborador(colaborador);
          const phone = processPhone(getCol(row, "CELULAR"));
          const cityRaw = getCol(row, "CIUDAD", "Ciudad");
          const city = cityRaw ? cityRaw.toUpperCase() : null;
          const branch = getCol(row, "TIENDA");
          const employeeCode = processEmployeeCode(
            getCol(row, "CODIGO", "CÓDIGO", "Codigo"),
          );
          return {
            city,
            companyId,
            companyName,
            dni: dni || null,
            lastnames: lastnames || null,
            lastnamesList: lastnamesList || [],
            names: names || null,
            namesList: namesList || [],
            phone,
            employeeCode,
            role: "salesRep",
            status: "active",
            type: "enterprise",
            branch: branch || null,
          };
        })
        .filter((u) => u.dni && u.names);
    },

    processExcelRowsToUserObjects(excelRows, companyId, companyName) {
      // Función para procesar teléfono: agregar +593 y quitar el primer 0
      const processPhone = (phone) => {
        if (!phone) return null;
        let processed = String(phone).trim();
        // Quitar espacios y caracteres especiales
        processed = processed.replace(/\s+/g, "").replace(/[^\d+]/g, "");
        // Si empieza con 0, quitarlo
        if (processed.startsWith("0")) {
          processed = processed.substring(1);
        }
        // Si no empieza con +593, agregarlo
        if (!processed.startsWith("+593")) {
          processed = "+593" + processed;
        }
        return processed;
      };

      // Función para determinar el rol basado en el cargo
      const determineRole = (cargo) => {
        if (!cargo) return "salesRep"; // Default
        const cargoLower = String(cargo).toLowerCase();
        if (
          cargoLower.includes("jefe de almacen") ||
          cargoLower.includes("jefe de almacén")
        ) {
          return "manager";
        } else if (cargoLower.includes("vendedor")) {
          return "salesRep";
        }
        return "salesRep"; // Default
      };

      return excelRows
        .map((row) => {
          // Función helper para buscar columnas con diferentes variaciones
          const getColumnValue = (variations) => {
            for (const variation of variations) {
              if (row[variation] !== undefined && row[variation] !== null) {
                return String(row[variation]).trim();
              }
            }
            return "";
          };

          // Extraer datos de las columnas con múltiples variaciones
          const nombre1 = getColumnValue([
            "Nombre 1",
            "NOMBRE 1",
            "nombre 1",
            "Nombre1",
            "NOMBRE1",
          ]);
          const nombre2 = getColumnValue([
            "Nombre 2",
            "NOMBRE 2",
            "nombre 2",
            "Nombre2",
            "NOMBRE2",
          ]);
          const apellido1 = getColumnValue([
            "Apellido 1",
            "APELLIDO 1",
            "apellido 1",
            "Apellido1",
            "APELLIDO1",
          ]);
          const apellido2 = getColumnValue([
            "Apellido 2",
            "APELLIDO 2",
            "apellido 2",
            "Apellido2",
            "APELLIDO2",
          ]);
          const ci = getColumnValue(["CI", "ci", "Cédula", "Cedula", "cedula"]);
          const ciudad = getColumnValue([
            "CIUDAD",
            "Ciudad",
            "ciudad",
            "Ciudad",
          ]);
          const telefonoOficina = getColumnValue([
            "Telefono Oficina",
            "TELEFONO OFICINA",
            "Teléfono Oficina",
            "telefono oficina",
            "TelefonoOficina",
          ]);
          const cargo = getColumnValue(["CARGO", "Cargo", "cargo"]);
          const nombreAlmacenNuevo = getColumnValue([
            "NOMBRE ALMACEN NUEVO",
            "Nombre Almacen Nuevo",
            "nombre almacen nuevo",
            "NombreAlmacenNuevo",
          ]);

          // Construir names y lastnames
          const names = [nombre1, nombre2].filter((n) => n).join(" ");
          const lastnames = [apellido1, apellido2].filter((n) => n).join(" ");

          // Construir arrays
          const namesList = [nombre1, nombre2].filter((n) => n);
          const lastnamesList = [apellido1, apellido2].filter((n) => n);

          // Procesar teléfono
          const phone = processPhone(telefonoOficina);

          // Determinar rol
          const role = determineRole(cargo);

          // Crear objeto usuario (userId y promoCode se generarán en el backend)
          const userObject = {
            city: ciudad || null,
            companyId: companyId,
            companyName: companyName,
            dni: ci || null,
            email: null,
            isProfileCompleted: true,
            lastnames: lastnames || null,
            lastnamesList: lastnamesList.length > 0 ? lastnamesList : [],
            names: names || null,
            namesList: namesList.length > 0 ? namesList : [],
            phone: phone,
            photoURL: null,
            role: role,
            status: "active",
            type: "enterprise",
            branch: nombreAlmacenNuevo || null,
          };

          return userObject;
        })
        .filter((user) => {
          // Filtrar usuarios que no tengan número de teléfono, nombres o correo
          const hasPhone = user.phone && user.phone.trim() !== "";
          const hasNames = user.names && user.names.trim() !== "";
          const hasEmail = user.email && user.email.trim() !== "";

          // Solo incluir si tiene teléfono Y nombres (el correo puede ser null según especificaciones)
          return hasPhone && hasNames;
        });
    },
  },
};
</script>

<style scoped>
.card {
  margin-top: 20px;
}

h6 {
  color: #7d0c7e;
  font-weight: bold;
}

/* Custom styles for DataTable */
:deep(.dataTable-top) {
  padding: 10px 15px !important;
}

:deep(.dataTable-search) {
  float: right;
}

:deep(.dataTable-input) {
  border: 1px solid #e9ecef;
  border-radius: 5px;
  background-color: #fff;
  padding: 6px 12px;
}

:deep(.dataTable-selector) {
  padding: 6px 12px;
  border: 1px solid #e9ecef;
  border-radius: 5px;
  background-color: #fff;
}

:deep(.dataTable-table) {
  border-collapse: collapse;
  width: 100%;
}

:deep(.dataTable-table > tbody > tr > td) {
  padding: 12px 15px;
  vertical-align: middle;
  font-size: 0.875rem;
}

:deep(.dataTable-pagination .active a) {
  background-color: #7d0c7e !important;
  border-color: #7d0c7e !important;
}

:deep(.dataTable-pagination li:not(.active):not(.disabled) a:hover) {
  background-color: #f8f9fa;
  color: #7d0c7e;
}

.company-info {
  background: #f1f1f1;
  padding: 1rem;
  border-radius: 0.25rem;

  .info-item {
    margin-bottom: 0.5rem;
  }
}

/* Modal styling */
.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content4 {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  margin: 0 1rem;
  padding: 1rem;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1rem 0 1rem;
}

.modal-body {
  padding: 0 1rem 1rem 1rem;
  overflow-y: auto;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0 1rem 1rem 1rem;
}
</style>
